import { Node } from 'react-checkbox-tree';

export const getAllExpanded = (x: Node[]) => {
    const all: string[] = [];

    if (Array.isArray(x)) {
        x.forEach((el) => {
            if (Array.isArray(el.children) && el.children.length > 0) {
                all.push(el.value, ...getAllExpanded(el.children));
            }
        });
    }

    return all;
};
